import MultiStepForm from './MultiStepForm';

export default function HeroSection() {
  return (
    <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/a7a45bef519addb86f62650fa4d00e15/d3245e36f6f323dacc7a1884fddf254e.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/85 via-blue-900/80 to-blue-900/85"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight font-display">
              Professional QuickBooks Bookkeeping Services in El Paso, Texas
            </h2>
            <p className="text-lg mb-4 text-blue-100 leading-relaxed">
              Expert <strong>bookkeeping services in El Paso</strong> designed to help local businesses maintain accurate financial records and make informed decisions.
            </p>
            <p className="text-base mb-6 text-blue-100 leading-relaxed">
              Our <strong>El Paso bookkeeping</strong> team specializes in QuickBooks solutions for small and medium-sized businesses throughout West Texas. We provide reliable, affordable <strong>bookkeeping services</strong> that save you time and reduce stress.
            </p>
            
            <div className="flex flex-wrap gap-4 mb-6">
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                </div>
                <span className="text-sm">QuickBooks Certified</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                </div>
                <span className="text-sm">Local El Paso Team</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                </div>
                <span className="text-sm">Affordable Pricing</span>
              </div>
            </div>

            <div className="flex items-center space-x-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-2 flex items-center justify-center">
                  <i className="ri-user-line text-teal-400 text-3xl"></i>
                </div>
                <div className="text-xl font-bold"></div>
                <div className="text-xs text-blue-200">Local In Person Help</div>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-2 flex items-center justify-center">
                  <i className="ri-building-line text-teal-400 text-3xl"></i>
                </div>
                <div className="text-xl font-bold">15+</div>
                <div className="text-xs text-blue-200">Business Experience</div>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-2 flex items-center justify-center">
                  <i className="ri-star-fill text-teal-400 text-3xl"></i>
                </div>
                <div className="text-xl font-bold"></div>
                <div className="text-xs text-blue-200">Happy Clients</div>
              </div>
            </div>
          </div>

          <div className="lg:pl-8">
            <MultiStepForm />
          </div>
        </div>
      </div>
    </section>
  );
}
